import { useContext, useEffect, useState } from "react";
import { useHistory, Redirect } from "react-router-dom";
import { IoArrowForwardOutline } from "react-icons/io5";

import "./tour-detail.scss";
import TourPassangers from "./TourPassangers.jsx";
import { TourInfo, Attention, PaymentGateway } from "./Components";
import Payment from "./Payment";
import Helmet from "react-helmet";
import logo from "../assets/image/20211007_120244.jpg";
import AuthenticationContext from "Authentication/AuthenticationContext.ts";
import { getTourInfoForReserve, reserveTour } from "services/reserveTour";
import Swal from "sweetalert2";
import image from "../assets/image/jomesob.jpg";
import Loader from "utilities/Loader";
import toast, { Toaster } from "react-hot-toast";

export default function ReserveTour(props) {
  const history = useHistory();

  const { userInfo, isLogged } = useContext(AuthenticationContext);

  const [load, setLoad] = useState(false);
  const [info, setInfo] = useState({
    title: "",
    type: "",
    startDate: "",
    startTime: "",
    startPlace: "",
    cover_pic: "",
  });
  const [payType, setPayType] = useState("online");
  const [payPrice, setPayPrice] = useState(0);
  const [wallet, setWallet] = useState(false);
  const [totalPricePerPerson, setTotalPricePerPerson] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [pastPassangers, setPastPassangers] = useState([]);
  const [price, setPrice] = useState({
    basePrice: 0,
    otherPrices: [],
    absolutePrice: { price: 0, state: true },
    reservation: false,
    reserveWithoutPrepayment: { state: false },
    reserveWithPrepayment: { state: false, price: 0 },
  });
  const [busType, setBusType] = useState();
  const [seats, setSeats] = useState([]);
  const [selectedSeats, setSelectedSeats] = useState(0);
  const [rules, setRules] = useState(false);
  const [passangers, setPassangers] = useState([]);
  const [tourId, setTourId] = useState(-1);
  const [selectedGateway, setSelectedGateway] = useState("zarinpal");
  const [capacity, setCapacity] = useState(0);

  const changeSeats = (theSeats) => {
    setSeats(theSeats);
  };
  const changeBusType = (type) => setBusType(type);
  const changeSelectedGateway = (gateway) => setSelectedGateway(gateway);

  const addPassanger = (passanger) => {
    setPassangers([...passangers, passanger]);
  };

  const changePrice = (x) => {
    setPrice(x);
  };

  const changeRules = (x) => {
    setRules(x);
  };

  const pay = async () => {
    setLoad(false);
    let ac = price.otherPrices.reduce((total, value) => {
      if (value.state) total.push(value.id);
      return total;
    }, []);
    let res = await reserveTour(userInfo.id, tourId, seats, busType, totalPrice, payPrice, payType, passangers, ac);
    setLoad(true);
    if (res) history.push(res?.url);
    else
      Swal.fire({
        title: "خطا!",
        text: "مشکلی در ثبت اطلاعات بوجود آمده است، لطفا بعدا تلاش کنید.",
        icon: "error",
        showConfirmButton: true,
      });
  };

  useEffect(() => {
    async function loadPage(id) {
      let res = await getTourInfoForReserve(id, userInfo.id);
      setInfo(res.info);
      setCapacity(res.info.capacity);
      setSeats(res.seats);
      setBusType(res.busType);
      setPrice(res.prices);
      setPastPassangers(res.pastPassangers);
      setWallet(res.wallet);
      if (res.wallet !== false) {
        setPayType("wallet");
      }
      setLoad(true);
    }

    let id = props.match.params.id;
    loadPage(id).catch((error) => {
      console.log(error);
    });
    setTourId(id);
  }, []);

  useEffect(() => {
    setPastPassangers(pastPassangers.filter((value) => !passangers.some((val) => val.id == value.id)));
  }, [passangers]);

  useEffect(() => {
    let sum = 0;
    for (const x in price) {
      if (x == "otherPrices") {
        sum += price.otherPrices.reduce((total, value) => {
          if (value.state) {
            return total + value.price;
          }
          return total;
        }, 0);
      }
      if (price[x].state && typeof price[x].price !== "undefined") {
        sum += price[x].price;
      }
    }
    setTotalPricePerPerson(sum);
  }, [price]);

  useEffect(() => {
    let finalPrice = totalPricePerPerson * (passangers.length + 1);
    setTotalPrice(finalPrice);
    if (payType == "wallet") finalPrice -= wallet;
    setPayPrice(finalPrice > 0 ? finalPrice : 0);
  }, [totalPricePerPerson, wallet, passangers, payType]);
  function notLogged() {
    toast.error("شما وارد نشدید! ");
    return <Redirect to="/" />;
  }

  return (
    <>
      <Helmet>
        <title>{info.title + " | "} جمه صب</title>
      </Helmet>
      {!isLogged && notLogged()}
      {!load ? <Loader /> : ""}

      <div className="the-tour-reserve">
        <div className="the-image-container">
          <img className="the-image" alt="the tour" src={info.cover_pic != "" ? `http://mvc.dade24.ir/${info.cover_pic}` : image} />
        </div>
        <div className="the-container">
          <div className="w-100 d-flex justify-content-center">
            <div className="the-logo">
              <img alt="logo" src={logo} />
            </div>
          </div>
          <TourInfo info={info} />
          <Payment price={price} changePrice={changePrice} totalPrice={totalPricePerPerson} />
          <TourPassangers passangers={passangers} addPassanger={addPassanger} pastPassangers={pastPassangers} busType={busType} seats={seats} changeBusType={changeBusType} changeSeats={changeSeats} selectedSeats={selectedSeats} setSelectedSeats={setSelectedSeats} capacity={capacity} main_status={info.main_status} />
          {capacity == 0 ? (
            <div className="d-flex justify-content-center">
              <div className="the-alert"> ظرفیت این تور تکمیل شده است. </div>
            </div>
          ) : info.main_status != 4 ? (
            <div className="d-flex justify-content-center">
              <div className="the-alert"> این تور خارج از رزرو است. </div>
            </div>
          ) : capacity - (passangers.length + 1) <= 0 ? (
            <div className="d-flex justify-content-center">
              <div className="the-alert">شما نمیتوانید برای این تعداد تور رزرو کنید.</div>
            </div>
          ) : (
            <>
              <Attention rules={rules} changeRules={changeRules} />
              <PaymentGateway type={payType} changeType={setPayType} wallet={wallet} totalPrice={totalPrice} payPrice={payPrice} changeSelectedGateway={changeSelectedGateway} />
              {!rules ? <div className="the-alert">لطفا قوانین را مطالعه و قبول کنید.</div> : payType == "online" && selectedGateway == null ? <div className="the-alert">لطفا درگاه را انتخاب کنید.</div> : "1,2".includes(busType) && selectedSeats != passangers.length + 1 ? <div className="the-alert">لطفا به تعداد مسافرین صندلی انتخاب کنید.</div> : ""}
              <div className="buttons">
                <button className="btn btn-primary" disabled={!rules || (payType == "online" && selectedGateway == null) || ("1,2".includes(busType) && selectedSeats != passangers.length + 1)} onClick={pay}>
                  پرداخت
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
